import script from "./bulk-archive-buttons.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-archive-buttons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__